import {useSelector} from 'react-redux';
import {setErrorCatcher} from '@treatwell/ui';
import {errorCatcher} from '../../shared/utils/errorCatcher';
import {RouteProvider} from '../components/Router';
import {PageLayout} from '.';
import {store} from '../store';
import styles from './Page.module.css';
import {initialise} from '../store/slices/availability/slice';
import {
  selectAppRequestStatus,
  selectShowMultiStaffSelection,
} from '../store/slices/selectors';
import {GenericErrorPage} from '../Error';
import {LoadingSpinner} from '../components/LoadingSpinner';
import {Title} from '../components/Title';
import {isAvailabiltyRoute} from '../utils/isRoute';
import {useAppSelector} from '../hooks/store';
import {AppContainer} from '../components/App';
import {loadGTMLibrary} from '../utils/gtmTracking';
import {Tracking} from '../components/Tracking/Tracking';
import {availabilityPageType} from '../utils/generatePageTracking';
import {useEffect} from 'react';

if (isAvailabiltyRoute()) {
  setErrorCatcher({errorCatcher});
  store.dispatch(initialise({url: location.href})).then(() => {
    loadGTMLibrary();
  });
}

export const Availability = () => {
  const appStatus = useSelector(selectAppRequestStatus);
  const shouldShowMultiStaffSelection = useAppSelector(
    selectShowMultiStaffSelection,
  );

  useEffect(() => {
    if (appStatus === 'fulfilled' || appStatus === 'rejected') {
      window.Treatwell?.hideSkeleton?.();
    }
  }, [appStatus]);

  if (appStatus === 'rejected') {
    return <GenericErrorPage />;
  }

  if (appStatus !== 'fulfilled') {
    return (
      <div className={styles.loading}>
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <RouteProvider isAvailabiltyRoute>
      <Title isAvailabilty />
      <PageLayout isOnMultiStaffSelection={shouldShowMultiStaffSelection}>
        <AppContainer />
        <Tracking pageType={availabilityPageType} />
      </PageLayout>
    </RouteProvider>
  );
};
